import { render, staticRenderFns } from "./DisplayMode.vue?vue&type=template&id=5c247168&scoped=true"
import script from "./DisplayMode.vue?vue&type=script&lang=js"
export * from "./DisplayMode.vue?vue&type=script&lang=js"
import style0 from "./DisplayMode.vue?vue&type=style&index=0&id=5c247168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c247168",
  null
  
)

export default component.exports